module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="message-container">\n    <div class="zmags-target-overlay-message">\n        <h1>There has been a problem launching our help box</h1>\n        <h2>Please reach out to our <a href="mailto:support@zmags.com">Support Team</a></h2>\n    </div>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/zendesk/ZendeskErrorView.tpl
// module id = 3148
// module chunks = 0